"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ajaxRequest = ajaxRequest;
exports.getRetries = getRetries;
exports.getTimeout = getTimeout;
exports.sendWithAxios = sendWithAxios;
exports.setDefaultTimeout = setDefaultTimeout;
exports.setRetryTimeout = setRetryTimeout;
var _retryAxios = require("./retry-axios");
var _error = require("./error");
var _axios = _interopRequireDefault(require("axios"));
var _coreConfig = _interopRequireDefault(require("../core-config"));
var _coreLog = _interopRequireDefault(require("../core-log"));
var _coreMerge = _interopRequireDefault(require("../core-merge"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Handles making the backend request
 */
var defaultTimeout = 45000;
var retryTimeout = 30000;

// Filled in reverse order to use Array.pop instead of Array.shift
var retries = {};

/**
 * Provides a deep copy of retries
 * @return {object} a fresh copy on different send() calls
 */
function getRetries() {
  return _coreMerge["default"].merge({}, retries);
}

/**
 * Sets the default timer value
 * @param {number} timeout
 */
function setDefaultTimeout(timeout) {
  defaultTimeout = timeout;
}

/**
 * Sets the retry timeout value
 * @param {number} timeout
 */
function setRetryTimeout(timeout) {
  retryTimeout = timeout;
  retries = {
    429: [{
      timeout: retryTimeout
    },
    // second call (30 seconds)
    {
      timeout: retryTimeout
    } // first call (30 seconds)
    ]
  };
}

/**
 * initial retry population
 */
setRetryTimeout(retryTimeout);

/**
 * attach the interceptor with global axios instance
 */
(0, _retryAxios.attach)();

/**
 * retry axios configuration
 */
var raxConfig = {
  // HTTP methods to automatically retry.
  httpMethodsToRetry: ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT', 'PATCH', 'POST'],
  // You can detect when a retry is happening, and figure out how many
  // retry attempts have been made
  onRetryAttempt: function onRetryAttempt(err) {
    var _err$config$url;
    var cfg = (0, _retryAxios.getConfig)(err);
    var serviceKey = "".concat((_err$config$url = err.config.url) === null || _err$config$url === void 0 ? void 0 : _err$config$url.split('/').pop(), "-initTime");
    _coreConfig["default"].get(_coreConfig["default"].internal)[serviceKey] = Date.now();
    _coreLog["default"].log("Retry attempt #".concat(cfg.currentRetryAttempt));
  }
};

/**
 * Use axios or custom application stubbed network library.
 *
 * @return {*} The network library to use, defaults to axios
 */
function getNetworkLibrary() {
  var _config$get = _coreConfig["default"].get(_coreConfig["default"].external),
    stubNetwork = _config$get.stubNetwork;
  var _ref = _coreConfig["default"].get(_coreConfig["default"].internal).app || {},
    network = _ref.network;
  if (!stubNetwork || !network) {
    return _axios["default"];
  } else {
    return network(_axios["default"]);
  }
}

/**
 * Sends a request with the Axios network library
 *
 * @param {string} url The URL of the resource
 * @param {object} opts JS object containing all call options, including result callbacks
 * @param {Array} retries Array containing logic to retry the call.
 */
function sendWithAxios(url, opts) {
  var retries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getRetries();
  _coreLog["default"].log('making AJAX call to: ' + url);
  opts.url = url;
  getNetworkLibrary()(opts).then(function (response) {
    opts.success(response.data, response.status, response);
  })["catch"](function (error) {
    (0, _error.handleError)(url, opts, error, retries);
  });
}

/**
 * Replaces jQuery $.ajax calls.
 *
 * @param {string} url The URL of the resource
 * @param {object} options JS object containing all call options, including result callbacks
 */
function ajaxRequest(url, options) {
  var defaults = {
    timeout: _coreConfig["default"].get(_coreConfig["default"].internal).defaultNetworkTimeout || defaultTimeout,
    raxConfig: raxConfig
  };
  var opts = _coreMerge["default"].merge({}, defaults, options);
  sendWithAxios(url, opts);
}

/**
 * Gets timeout
 *
 * @return {*} default timeout
 */
function getTimeout() {
  return _coreConfig["default"].get(_coreConfig["default"].internal).defaultNetworkTimeout || defaultTimeout;
}
//# sourceMappingURL=request.js.map